let waitingRequests = 0;
const notify = () => window.dispatchEvent(new CustomEvent("studio-warming", {detail: waitingRequests > 0}));
/** Replay only requests explicitly rejected before processing by the sleeping gateway. */
export async function demoFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const deadline = Date.now() + 12 * 60_000;
  let waiting = false;
  try {
    while (true) {
      const response = await fetch(input, init);
      if (response.status !== 503 || response.headers.get("X-Demo-Warming") !== "1" || Date.now() >= deadline) return response;
      if (!waiting) { waiting = true; waitingRequests++; notify(); }
      await response.text();
      await new Promise(resolve => setTimeout(resolve, 5000));
      if (init?.signal?.aborted) throw new DOMException("Aborted", "AbortError");
    }
  } finally {
    if (waiting) { waitingRequests--; notify(); }
  }
}
